/**
 * @flow
 * @relayHash 493c7683c46ccc203adcaba6543f1916
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TrackerDestination = "LOGGI" | "RECIPIENT" | "SENDER" | "%future added value";
export type statusQueryVariables = {|
  trackingKey: string,
  postalCode?: ?string,
  companySecretId?: ?string,
|};
export type statusQueryResponse = {|
  +packageTracker: ?{|
    +eta: ?number,
    +packageInfo: ?{|
      +packageId: ?number,
      +trackingKey: ?string,
      +companyName: ?string,
      +companyHash: ?string,
    |},
    +redispatchInfo: ?{|
      +trackingCode: ?string,
      +maxPickupTime: ?number,
    |},
    +currentStatus: ?{|
      +error: ?number,
      +inProgress: ?boolean,
      +destination: ?TrackerDestination,
      +type: ?string,
    |},
    +shipperStatus: ?{|
      +code: ?number,
      +label: ?string,
      +description: ?string,
      +actionRequired: ?{|
        +reasonLabel: ?string,
        +reasonDescription: ?string,
      |},
    |},
    +destinationInfo: ?{|
      +firstLine: ?string
    |},
    +canAuthenticate: ?boolean,
  |}
|};
export type statusQuery = {|
  variables: statusQueryVariables,
  response: statusQueryResponse,
|};
*/

/*
query statusQuery(
  $trackingKey: String!
  $postalCode: String
  $companySecretId: String
) {
  packageTracker(trackingKey: $trackingKey, postalCode: $postalCode, companySecretId: $companySecretId) {
    eta
    packageInfo {
      packageId
      trackingKey
      companyName
      companyHash
    }
    redispatchInfo {
      trackingCode
      maxPickupTime
    }
    currentStatus {
      error
      inProgress
      destination
      type
    }
    shipperStatus {
      code
      label
      description
      actionRequired {
        reasonLabel
        reasonDescription
      }
    }
    destinationInfo {
      firstLine
    }
    canAuthenticate
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'trackingKey',
        type: 'String!',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'postalCode',
        type: 'String',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'companySecretId',
        type: 'String',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'LinkedField',
        alias: null,
        name: 'packageTracker',
        storageKey: null,
        args: [
          {
            kind: 'Variable',
            name: 'companySecretId',
            variableName: 'companySecretId'
          },
          {
            kind: 'Variable',
            name: 'postalCode',
            variableName: 'postalCode'
          },
          {
            kind: 'Variable',
            name: 'trackingKey',
            variableName: 'trackingKey'
          }
        ],
        concreteType: 'TrackerResultNode',
        plural: false,
        selections: [
          {
            kind: 'ScalarField',
            alias: null,
            name: 'eta',
            args: null,
            storageKey: null
          },
          {
            kind: 'LinkedField',
            alias: null,
            name: 'packageInfo',
            storageKey: null,
            args: null,
            concreteType: 'TrackerPackageInfoNode',
            plural: false,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'packageId',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'trackingKey',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'companyName',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'companyHash',
                args: null,
                storageKey: null
              }
            ]
          },
          {
            kind: 'LinkedField',
            alias: null,
            name: 'redispatchInfo',
            storageKey: null,
            args: null,
            concreteType: 'TrackerRedispatchInfoNode',
            plural: false,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'trackingCode',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'maxPickupTime',
                args: null,
                storageKey: null
              }
            ]
          },
          {
            kind: 'LinkedField',
            alias: null,
            name: 'currentStatus',
            storageKey: null,
            args: null,
            concreteType: 'TrackerStatusNode',
            plural: false,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'error',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'inProgress',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'destination',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'type',
                args: null,
                storageKey: null
              }
            ]
          },
          {
            kind: 'LinkedField',
            alias: null,
            name: 'shipperStatus',
            storageKey: null,
            args: null,
            concreteType: 'TrackerShipperStatusNode',
            plural: false,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'code',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'label',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'description',
                args: null,
                storageKey: null
              },
              {
                kind: 'LinkedField',
                alias: null,
                name: 'actionRequired',
                storageKey: null,
                args: null,
                concreteType: 'PrivateActionRequiredInfoNode',
                plural: false,
                selections: [
                  {
                    kind: 'ScalarField',
                    alias: null,
                    name: 'reasonLabel',
                    args: null,
                    storageKey: null
                  },
                  {
                    kind: 'ScalarField',
                    alias: null,
                    name: 'reasonDescription',
                    args: null,
                    storageKey: null
                  }
                ]
              }
            ]
          },
          {
            kind: 'LinkedField',
            alias: null,
            name: 'destinationInfo',
            storageKey: null,
            args: null,
            concreteType: 'TrackerDestinationInfoNode',
            plural: false,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'firstLine',
                args: null,
                storageKey: null
              }
            ]
          },
          {
            kind: 'ScalarField',
            alias: null,
            name: 'canAuthenticate',
            args: null,
            storageKey: null
          }
        ]
      }
    ];
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'statusQuery',
      type: 'Query',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    operation: {
      kind: 'Operation',
      name: 'statusQuery',
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    params: {
      operationKind: 'query',
      name: 'statusQuery',
      id: null,
      text:
        'query statusQuery(\n  $trackingKey: String!\n  $postalCode: String\n  $companySecretId: String\n) {\n  packageTracker(trackingKey: $trackingKey, postalCode: $postalCode, companySecretId: $companySecretId) {\n    eta\n    packageInfo {\n      packageId\n      trackingKey\n      companyName\n      companyHash\n    }\n    redispatchInfo {\n      trackingCode\n      maxPickupTime\n    }\n    currentStatus {\n      error\n      inProgress\n      destination\n      type\n    }\n    shipperStatus {\n      code\n      label\n      description\n      actionRequired {\n        reasonLabel\n        reasonDescription\n      }\n    }\n    destinationInfo {\n      firstLine\n    }\n    canAuthenticate\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = '389070445159e28a05173200f076b7fb';
module.exports = node;
